export const SET_ICP_PROGRESS = "SET_ICP_PROGRESS";
export const SET_CAMPAIGN_PROGRESS = "SET_CAMPAIGN_PROGRESS";
export const CLEAR_PROGRESS = "CLEAR_PROGRESS";
export const CLEAR_ALL_PROGRESS = "CLEAR_ALL_PROGRESS";
